//Generated File 
export default class CapabilityType{
	static readonly Approve = `Approve`;
	static readonly CanViewMoreMenu = `CanViewMoreMenu`;
	static readonly CanViewTransaction = `CanViewTransaction`;
	static readonly ChangeCapability = `ChangeCapability`;
	static readonly Commit = `Commit`;
	static readonly CreateDraft = `CreateDraft`;
	static readonly Delete = `Delete`;
	static readonly DeleteAfterApproval = `DeleteAfterApproval`;
	static readonly DeleteAfterPrint = `DeleteAfterPrint`;
	static readonly DeleteDocsInClosedShifts = `DeleteDocsInClosedShifts`;
	static readonly DeleteDraft = `DeleteDraft`;
	static readonly Duplicate = `Duplicate`;
	static readonly EditAfterApproval = `EditAfterApproval`;
	static readonly EditAfterCommit = `EditAfterCommit`;
	static readonly EditAfterPrint = `EditAfterPrint`;
	static readonly EditDocsInClosedShifts = `EditDocsInClosedShifts`;
	static readonly EditUnderApproval = `EditUnderApproval`;
	static readonly Export = `Export`;
	static readonly Import = `Import`;
	static readonly ListView = `ListView`;
	static readonly Other = `Other`;
	static readonly PrintDraft = `PrintDraft`;
	static readonly PrintMoreThanOnce = `PrintMoreThanOnce`;
	static readonly PrintOnce = `PrintOnce`;
	static readonly RecordView = `RecordView`;
	static readonly Revise = `Revise`;
	static readonly SaveDraft = `SaveDraft`;
	static readonly SearchView = `SearchView`;
	static readonly Unrevise = `Unrevise`;
	static readonly ViewWithFromDoc = `ViewWithFromDoc`;
}
